import * as React from 'react';

import { Button, LoadingPanel, PageSplitDescription, PageSplitTitle } from '@gitbook/spine-react';
import { useHeadTitle } from '@gitbook/util-react-head';
import { useLoadingState } from '@gitbook/util-react-hooks';

import { MFAScreenModal } from '../../Components';
import { useHistory } from '../../navigation';
import { type FirebaseActionURLParams, useAuthOperations } from '../../state';
import { LoginScreenLayout } from './LoginScreenLayout';

/**
 * Step to recover an email address.
 */
export function StepApplyRecoverEmailLink(props: {
    action: FirebaseActionURLParams;
}): React.ReactElement {
    const { action } = props;
    const { mfa, checkActionCode, applyActionCode } = useAuthOperations();
    const [loading, wrapLoading] = useLoadingState(true);
    const [recoveredEmail, setRecoveredEmail] = React.useState<string | undefined | null>(
        undefined
    );
    const history = useHistory();

    useHeadTitle('Recover email');

    React.useEffect(() => {
        wrapLoading(async () => {
            const info = await checkActionCode(action.oobCode);
            if (info) {
                await applyActionCode(action.oobCode);

                setRecoveredEmail(info.data.email);
            }
        });
    }, [action.oobCode]);

    if (mfa) {
        return <MFAScreenModal mfa={mfa} />;
    }

    if (loading) {
        return <LoadingPanel size="large" />;
    }

    const onGoToSignIn = () => {
        history.push({ pathname: history.location.pathname });
    };

    return (
        <LoginScreenLayout>
            <PageSplitTitle>Email recovery</PageSplitTitle>
            <PageSplitDescription>
                <p>
                    Your email has been recovered to "{recoveredEmail}". You can safely continue to
                    the application.
                </p>
            </PageSplitDescription>
            <Button
                size="large"
                label="Continue"
                kind="primary"
                className="mb-4"
                onPress={onGoToSignIn}
            />
        </LoginScreenLayout>
    );
}
